/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import './style.scoped.scss';
import { setCurrentDocument } from '../../store/Document/documentActions';
import PaginatedList from '../PaginatedList';
import $ from 'jquery';
import CloseButton from '../Buttons/CloseButton';
import Search from './SearchDocs';
import { TranslateWorkaround } from '../../assets/constants/strings';
import { RGTitleSearch } from '../../services/search';

const DocListModal = ({
  selectedLevel,
  clientDocs,
  levelTwos,
  currentDocument,
  setCurrentDocument,
  onDismiss,
  handleSearch,
}) => {
  // cleanup on dismiss
  useEffect(() => {
    $('#DocsListModal').on('hide.bs.modal', () => {
      setSelectedLevelOne(null);
      setSelectedLevelTwo(null);
      setSelectedLevelThree(null);
      setSelectedLevelFour(null);

      onDismiss();
      setDisplaySearch(false);
      setIsSearch(false);
      setSearchValue('');
      setSearchResult(null);
      setDisplayDocuments([]);

      setSelectedExternally(true);
    });
  }, []);

  const hideModal = () => $('#DocsListModal').modal('hide');

  const handleSetDocument = async (slug) => {
    hideModal();
    await setCurrentDocument(slug);
  };

  const [modalTitle, setModalTitle] = useState('');
  const [isSearch, setIsSearch] = useState(false);
  const [displaySearch, setDisplaySearch] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [searchResult, setSearchResult] = useState(null);

  const [selectedLevelOne, setSelectedLevelOne] = useState(null);
  const [selectedLevelTwo, setSelectedLevelTwo] = useState(null);
  const [selectedLevelThree, setSelectedLevelThree] = useState(null);
  const [selectedLevelFour, setSelectedLevelFour] = useState(null);

  const [displayLevelTwos, setDisplayLevelTwos] = useState([]);
  const [displayLevelThrees, setDisplayLevelThrees] = useState([]);
  const [displayLevelFours, setDisplayLevelFours] = useState([]);
  const [displayDocs, setDisplayDocuments] = useState([]);

  const [selectedExternally, setSelectedExternally] = useState(true);

  const handleLevelSelected = (selected, externally = false) => {
    if (selectedExternally !== externally) {
      setSelectedExternally(externally);
    }
    switch (selected.level) {
      case 'levelOne': {
        setSelectedLevelOne(selected.value);
        return;
      }
      case 'levelTwo': {
        // the only way a user can select anything above level one is from the breadcrumbs,
        // meaning the other levels are set as well
        if (externally) setSelectedLevelOne(currentDocument.levelOne);
        setSelectedLevelTwo(selected.value);
        return;
      }
      case 'levelThree': {
        if (externally) {
          setSelectedLevelOne(currentDocument.levelOne);
          setSelectedLevelTwo(currentDocument.levelTwo);
        }
        setSelectedLevelThree(selected.value);
        return;
      }
      case 'levelFour': {
        if (externally) {
          setSelectedLevelOne(currentDocument.levelOne);
          setSelectedLevelTwo(currentDocument.levelTwo);
          setSelectedLevelThree(currentDocument.levelThree);
        }
        setSelectedLevelFour(selected.value);
        return;
      }
      default:
        return;
    }
  };

  // const handleSearch = (input) => {
  //   if (input.length > 0) {
  //     setIsSearch(true);
  //     setSearchValue(input);
  //   } else {
  //     setIsSearch(false);
  //     setSearchValue('');
  //     setSearchResult(null);
  //     setDisplaySearch(false);
  //   }
  // };

  useEffect(() => {
    if (selectedLevel) handleLevelSelected(selectedLevel, true);
  }, [selectedLevel]);

  useEffect(() => {
    try {
      if (
        levelTwos &&
        (selectedLevelOne || (searchValue && searchValue.length > 0))
      ) {
        let docs = [];
        // local search, means search this LevelOne only
        if (isSearch) {
          if (selectedLevelOne !== null) {
            setModalTitle(
              `Searching ${selectedLevelOne.Title} for: ${searchValue}`
            );
          }

          if (selectedLevelTwo) setSelectedLevelTwo(null);
          if (selectedLevelThree) setSelectedLevelThree(null);
          if (selectedLevelFour) setSelectedLevelFour(null);

          docs = searchLevelOne(searchValue);
          setSearchResult(docs);
        } // LevelOne selected, means display available docs for it
        else {
          if (selectedLevelOne !== null) {
            setModalTitle(selectedLevelOne.Title);
            docs = filterDocsBy('levelOne', selectedLevelOne.Title, true);
          }
        }

        const levelTwosDisplayed = []; // empty arr

        docs.forEach((doc) => {
          if (!levelTwosDisplayed.some((item) => item.ID === doc.levelTwo.ID)) {
            levelTwosDisplayed.push(doc.levelTwo);
          }
        });

        setDisplayLevelTwos(
          levelTwosDisplayed.sort((a, b) => (a.Sort > b.Sort ? 1 : -1))
        );
      } else {
        setDisplayDocuments([]);
        setDisplayLevelTwos([]);
        setDisplayLevelThrees([]);
        setDisplayLevelFours([]);
      }
    } catch (e) {
      console.log('ERROR DocListModal useEffect level one \n\n', e.message);
    }
  }, [selectedLevelOne, levelTwos, isSearch, searchValue]);

  // const searchLevelOne = (input) => {
  //   return selectedLevelOne
  //     ? RGTitleSearch(input, clientDocs).filter((doc) => doc.levelOne.ID === selectedLevelOne.ID)
  //     : [];
  // };

  const searchLevelOne = (input) => {
    const normalizeText = (text) =>
      text
        .toLowerCase()
        .replace(/[^a-z0-9\s]/gi, '') // Remove special characters except spaces
        .trim()
        .split(/\s+/); // Split by spaces after normalization

    const normalizedInput = normalizeText(input); // Normalize the input

    const docs = clientDocs
      .filter((doc) => doc.levelOne.ID === selectedLevelOne.ID)
      .filter((doc) => {
        const normalizedTitle = normalizeText(doc.title); // Normalize the document title
        return normalizedInput.every((inputWord) =>
          normalizedTitle.some((titleWord) => titleWord.includes(inputWord))
        ); // Check if every word in the input is contained in the title
      });
    return docs;
  };

  const filterDocsBy = (key, value, exact) => {
    if (exact) {
      return clientDocs
        .filter((document) => document[key].Title === value)
        .sort((a, b) =>
          a.title.localeCompare(b.title, undefined, { numeric: true })
        );
    } else {
      const regExWord = new RegExp(`(\\b${value}\\b)`, 'gi');
      return clientDocs
        .filter((document) => document[key].match(regExWord))
        .sort((a, b) =>
          a.title.localeCompare(b.title, undefined, { numeric: true })
        );
    }
  };

  // handler for selecting a Level Two from the list
  useEffect(() => {
    try {
      if (selectedLevelOne !== null && selectedLevelTwo !== null) {
        // means user is navigating in here, so the lower levels need to be cleared
        if (!selectedExternally) {
          if (selectedLevelThree) setSelectedLevelThree(null);
          if (selectedLevelFour) setSelectedLevelFour(null);
        }

        // if we are in a search, only show the levels that matched a document from search
        const availableDocs = searchResult !== null ? searchResult : clientDocs;

        const docs = availableDocs.filter(
          (doc) =>
            doc.levelTwo.ID === selectedLevelTwo.ID &&
            // in parent search, no LevelOne was selected
            doc.levelOne.ID === selectedLevelOne.ID
        );

        const levelThreeList = []; // empty arr

        docs.forEach((doc) => {
          if (
            doc.levelThree &&
            !levelThreeList.some((item) => item.ID === doc.levelThree.ID)
          ) {
            levelThreeList.push(doc.levelThree); // populate with sos
          }
        });

        // level 3 list has to be documents without level 3 and level 3 list items
        const docsWithoutLevel3 = docs.filter((doc) => doc.levelThree === null);

        setDisplayLevelThrees([
          ...levelThreeList
            .map((lvl3) => {
              const newItem = { itemType: 'LevelItem', LevelItem: lvl3 };
              return newItem;
            })
            .sort((a, b) => (a.LevelItem.Sort > b.LevelItem.Sort ? 1 : -1)),
          ...docsWithoutLevel3
            .map((doc) => {
              const newItem = { itemType: 'Document', Document: doc };
              return newItem;
            })
            .sort((a, b) =>
              a.Document.title.localeCompare(b.Document.title, undefined, {
                numeric: true,
              })
            ),
        ]);
      }
      // select if we are dealing with search results
      else if (searchResult && searchResult.length > 0 && !selectedLevelTwo) {
        setSelectedLevelTwo(displayLevelTwos[0]);
      } else setDisplayLevelThrees([]);
    } catch (e) {
      console.log('ERROR DocListModal useEffect level two \n\n', e.message);
    }
  }, [selectedLevelTwo, searchResult]);

  // handler for selecting a Level Three from the list
  useEffect(() => {
    try {
      if (
        selectedLevelOne !== null &&
        selectedLevelTwo !== null &&
        selectedLevelThree !== null
      ) {
        // means user is navigating in here, so the lower levels need to be cleared
        if (!selectedExternally && selectedLevelFour)
          setSelectedLevelFour(null);

        // if we are in a search, only show the levels that matched a document from search
        const availableDocs = searchResult !== null ? searchResult : clientDocs;

        const docs = availableDocs.filter(
          (doc) =>
            doc.levelTwo.ID === selectedLevelTwo.ID &&
            doc.levelThree !== null &&
            doc.levelThree.ID === selectedLevelThree.ID &&
            doc.levelOne.ID === selectedLevelOne.ID
        );

        const levelFourList = []; // empty arr

        docs.forEach((doc) => {
          if (
            doc.levelFour &&
            !levelFourList.some((item) => item.ID === doc.levelFour.ID)
          ) {
            levelFourList.push(doc.levelFour);
          }
        });

        // level 4 list has to be documents without level 4 and level 4 list items
        const docsWithoutLevel4 = docs.filter((doc) => doc.levelFour === null);

        setDisplayLevelFours([
          ...levelFourList
            .map((lvl4) => {
              const newItem = { itemType: 'LevelItem', LevelItem: lvl4 };
              return newItem;
            })
            .sort((a, b) => (a.LevelItem.Sort > b.LevelItem.Sort ? 1 : -1)),
          ...docsWithoutLevel4
            .map((doc) => {
              const newItem = { itemType: 'Document', Document: doc };
              return newItem;
            })
            .sort((a, b) =>
              a.Document.title.localeCompare(b.Document.title, undefined, {
                numeric: true,
              })
            ),
        ]);
      }
      // select if we are dealing with search results
      else if (
        searchResult &&
        searchResult.length > 0 &&
        !selectedLevelThree &&
        displayLevelThrees.length > 0 &&
        displayLevelThrees.filter((item) => item.itemType === 'LevelItem')
          .length > 0
      ) {
        setSelectedLevelThree(
          displayLevelThrees.filter((item) => item.itemType === 'LevelItem')[0]
            .LevelItem
        );
      } else setDisplayLevelFours([]);
    } catch (e) {
      console.log('ERROR DocListModal useEffect level three \n\n', e.message);
    }
  }, [selectedLevelThree, displayLevelThrees]);

  // handler for selecting a Level Four from the list
  useEffect(() => {
    try {
      if (
        selectedLevelOne !== null &&
        selectedLevelTwo !== null &&
        selectedLevelThree !== null &&
        selectedLevelFour !== null
      ) {
        // if we are in a search, only show the levels that matched a document from search
        const availableDocs = searchResult !== null ? searchResult : clientDocs;

        const docs = availableDocs.filter(
          (doc) =>
            doc.levelTwo.ID === selectedLevelTwo.ID &&
            doc.levelThree &&
            doc.levelThree.ID === selectedLevelThree.ID &&
            doc.levelFour &&
            doc.levelFour.ID === selectedLevelFour.ID &&
            doc.levelOne.ID === selectedLevelOne.ID
        );

        setDisplayDocuments([
          ...docs.map((doc) => {
            const newItem = { itemType: 'Document', Document: doc };
            return newItem;
          }),
        ]);
      }
      // select if we are dealing with search results
      else if (
        searchResult &&
        searchResult.length > 0 &&
        !selectedLevelFour &&
        displayLevelFours.length > 0 &&
        displayLevelFours.filter((item) => item.itemType === 'LevelItem')
          .length > 0
      ) {
        setSelectedLevelFour(
          displayLevelFours.filter((item) => item.itemType === 'LevelItem')[0]
            .LevelItem
        );
      } else setDisplayDocuments([]);
    } catch (e) {
      console.log('ERROR DocListModal useEffect level four \n\n', e.message);
    }
  }, [selectedLevelFour, displayLevelFours]);

  useEffect(() => {
    // always try to scroll to the end of the list
    // as soon as the user selects a new item
    setTimeout(() => {
      const listElement = document.getElementById(`DocsList`);
      if (listElement) listElement.scrollLeft = listElement.scrollWidth;
    }, 100);
  }, [displayLevelTwos, displayLevelThrees, displayLevelFours, displayDocs]);

  return (
    <div className='modal' id='DocsListModal'>
      <div className='modal-dialog modal-dialog-centered modal-xl'>
        <div className='modal-content'>
          <div className='doc-wrapper p-0'>
            <div
              className={`doc-wrapper__header py-2${
                displaySearch ? ' search-expanded' : ''
              }`}
            >
              <div className='modal-title-wrapper'>
                <CloseButton
                  className='doc-wrapper__close'
                  title='Dismiss Modal'
                  handleClose={hideModal}
                  white
                />
                {modalTitle && (
                  <p
                    className={`font-weight-bold doc-wrapper__title mb-0${TranslateWorkaround(
                      modalTitle
                    )}`}
                  >
                    {modalTitle}
                  </p>
                )}
              </div>
              <Search
                handleSearch={handleSearch}
                isExpanded={displaySearch}
                displaySearch={() => setDisplaySearch(true)}
              />
            </div>

            {searchResult?.length > 0 ? (
              <PaginatedList
                isSearch
                searchValue={searchValue}
                DisplayList={searchResult}
                handleSetDocument={handleSetDocument}
              />
            ) : (
              <div className='doc-wrapper__content' id='DocsList'>
                {displayLevelTwos && displayLevelTwos.length > 0 ? (
                  <PaginatedList
                    DisplayList={displayLevelTwos
                      .sort((a, b) => (a.Sort > b.Sort ? 1 : -1))
                      .map((lvl2) => ({
                        itemType: 'LevelItem',
                        LevelItem: lvl2,
                      }))}
                    selectedItem={selectedLevelTwo}
                    handleSelectedLevel={(item) =>
                      handleLevelSelected({ level: 'levelTwo', value: item })
                    }
                  />
                ) : (
                  <div
                    className='alert alert-danger my-3 mx-auto px-4'
                    role='alert'
                    aria-label='No Documents'
                  >
                    No matching documents found.
                  </div>
                )}
                {selectedLevelTwo &&
                  displayLevelThrees &&
                  displayLevelThrees.length > 0 && (
                    <PaginatedList
                      DisplayList={displayLevelThrees}
                      selectedItem={selectedLevelThree}
                      handleSelectedLevel={(item) =>
                        handleLevelSelected({
                          level: 'levelThree',
                          value: item,
                        })
                      }
                      handleSetDocument={handleSetDocument}
                    />
                  )}
                {selectedLevelThree &&
                  displayLevelFours &&
                  displayLevelFours.length > 0 && (
                    <PaginatedList
                      DisplayList={displayLevelFours}
                      selectedItem={selectedLevelFour}
                      handleSelectedLevel={(item) =>
                        handleLevelSelected({
                          level: 'levelFour',
                          value: item,
                        })
                      }
                      handleSetDocument={handleSetDocument}
                    />
                  )}
                {selectedLevelFour && displayDocs && displayDocs.length > 0 && (
                  <PaginatedList
                    DisplayList={displayDocs}
                    handleSetDocument={handleSetDocument}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = { setCurrentDocument };

const mapStateToProps = (state) => ({
  levelTwos: state.client.levelTwoList,
  clientDocs: state.client.documents,
  currentDocument: state.document.currentDocument,
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(DocListModal);
